import React from 'react';
import { CountDownMessage } from '../CountDownMessage';
import { DropPenaltyMessage } from '../DropPenaltyMessage';
import { UndroppableMessage } from '../UndroppableMessage';
import { DropShiftHeaderMessageType } from '../DropShiftModalContentTypes';
import { View } from '@amzn/atoz-web/View';
export var HeaderMessage = function (_a) {
    var dropDeadline = _a.dropDeadline, type = _a.type;
    var renderMessage = function () {
        if (type === DropShiftHeaderMessageType.countdown) {
            return React.createElement(CountDownMessage, { dropDeadline: dropDeadline, showPreText: true });
        }
        if (type === DropShiftHeaderMessageType.dropPenalty) {
            return React.createElement(DropPenaltyMessage, null);
        }
        return React.createElement(UndroppableMessage, null);
    };
    return React.createElement(View, { dataTestId: "HeaderMessage" }, renderMessage());
};
